import { render, staticRenderFns } from "./CreateReturnOrderDispatchFrame.vue?vue&type=template&id=22259018&scoped=true&"
import script from "./CreateReturnOrderDispatchFrame.vue?vue&type=script&lang=js&"
export * from "./CreateReturnOrderDispatchFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22259018",
  null
  
)

export default component.exports